import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

export class MobileNavBar extends Component {
  render() {
    const { pathname, logo, logoWidth, authenticated, funnelStepper } = this.props;
    const logoProps = {
      src: logo,
      style: { width: logoWidth },
    };
    const slug = pathname ? pathname.split('/').pop() : '';
    const displayBorderBottom = ![
      'intro',
      'role',
      'organization-type',
      'organization-details',
      'sign-up',
      'ready-to-post',
      'persona',
      'request-consultation',
    ].includes(slug);

    return (
      <div>
        <div className="mobileNavBarV2Placeholder"></div>
        <div className={classNames('mobileNavBarV2', { 'border-bottom': displayBorderBottom })}>
          {this.props.authenticated && (
            <i className="material-icons" onClick={this.props.toggleCollapsed}>
              reorder
            </i>
          )}
          {!authenticated ? (
            <a href="https://www.go4.io/" target=" _blank" rel="noopener noreferrer">
              <img {...logoProps} className="logo" alt="Go4" />
            </a>
          ) : (
            <Link to={this.props.logoUrl ? this.props.logoUrl : '/'}>
              <img {...logoProps} className="logo" alt="Go4" />
            </Link>
          )}
          {funnelStepper?.backTo && (
            <div className="nav-back-container">
              <Link to={funnelStepper.backTo} className="back-btn gotham-medium-font">
                <div>Back</div>
              </Link>
            </div>
          )}
          {['athletic-trainer-sign-up'].includes(slug) && (
            <div className="nav-login-container">
              <Link to="/deeplink-sign-up" className="login-btn gotham-medium-font">
                <div>Go to App</div>
              </Link>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default MobileNavBar;
